if (process.env.NODE_ENV === 'development') require('preact/debug');

import { h, render } from 'preact';
import { App } from './app/App';

render(<App />, document.getElementById('app') as HTMLElement);
